import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "m19.928 18.8-.788-.788c.413-.623.65-1.365.65-2.163a3.94 3.94 0 0 0-3.94-3.941 3.936 3.936 0 0 0-3.933 3.95 3.936 3.936 0 0 0 6.105 3.291l.788.788a.8.8 0 0 0 1.137 0 .81.81 0 0 0-.019-1.136"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M20.167 8.003c0 1.09-.175 2.099-.477 3.034-.055.192-.284.247-.45.128a5.8 5.8 0 0 0-3.473-1.137 5.786 5.786 0 0 0-5.775 5.775c0 .99.256 1.962.742 2.824.147.256-.027.586-.302.486-2.21-.752-6.674-3.493-8.122-8.076a9.8 9.8 0 0 1-.477-3.034c0-2.833 2.283-5.125 5.097-5.125 1.66 0 3.144.807 4.07 2.045a5.09 5.09 0 0 1 4.07-2.045c2.814 0 5.097 2.292 5.097 5.125"
    }, null, -1)
  ]))]))
}
export default { render: render }